export const PRICE_VARIABLE = '{price}';
export const FREE_TRIAL_VARIABLE = '{freeTrialDays}';
export const COUNTDOWN_EVENT_VARIABLE = '{countdownEvent}';
export const DISCOUNT_PRICE_VARIABLE = '{discountPrice}';
export const DISCOUNTED_MONTHS_VARIABLE = '{discountedMonths}';
export const REM_MONTHS_VARIABLE = '{remainingMonths}';
export const STATIC_IMAGE_URL = 'https://static.dazndn.com/icons/';
export const SAVING_PRICE_VARIABLE = '{savingPrice}';

export type IImageSrcSet = [
    mobile: string,
    tablet: string,
    web: string,
    livingRoom: string
];

export enum BadgeTypes {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    GOLDEN = 'golden'
}

export enum ButtonTypes {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    GOLDEN = 'golden'
}

export interface IImage {
    mobile?: string;
    tablet?: string;
    web?: string;
    livingRoom?: string;
    default?: string;
    src: string;
    srcSet?: IImageSrcSet;
}

export interface IButton {
    displayName?: string;
    label: string;
    freeTrialLabel: string;
    discountLabel?: string;
    mobileButtonLabel: string;
    type: 'Primary' | 'Secondary' | 'Tertiary' | 'Quaternary';
    scrollAction?: 'None' | 'ScrollToTier' | 'ScrollToCompitionsRails';
    startIcon: IImage;
    endIcon: IImage;
    navigationType: 'Internal' | 'External';
    navigationLink: string;
    navigationAction: string;
    navigationChapterName: string;
    navigationInfo: Record<string, unknown>;
    buttonTrackingId: string;
    buttonLabel?: string;
    entitlementSetId?: string;
    billingPeriod?: string;
    promoCode?: string;
    buttonId?: string;
    action: (buttonProps?: Record<string, unknown>) => void;
}

export interface IContentTierButton {
    label: string;
    mobileButtonLabel: string;
    type: 'Primary' | 'Secondary' | 'Tertiary' | 'Quaternary';
    startIcon: IImage;
    endIcon: IImage;
    buttonImage: IImage;
    navigationType: 'Internal' | 'External';
    buttonHref: string;
    navigationAction: string;
    promoCode: string;
    chapterName: string;
    navigationInfo: Record<string, unknown>;
    buttonTrackingId: string;
    billingPeriod: string;
    entitlementSetId: string;
    isFreemium: boolean;
    action: (
        planSelectorShown?: string,
        billingPlan?: string,
        preselectBillingPeriod?: boolean
    ) => void;
}

export type ContentComponent = {
    fields: {
        entries: {
            fields: {
                key: string;
                value: string;
            };
        }[];
    };
};

export type PartialContentfulResponse = {
    items: {
        fields: {
            pages: string[];
            components: ContentComponent[];
        };
    }[];
};
